const ga = (...args) => {
  if (typeof window !== 'undefined' && typeof window.ga == 'function') {
    window.ga(...args)
  }
}

export default ga



// WEBPACK FOOTER //
// ./common/utils/ga.js